// extracted by mini-css-extract-plugin
export var modalFooter = "_rr-0";